import { CellChange, ChangeSource } from "handsontable/common";
import { useCallback } from "react";
import {
    SpreadsheetAccessParams,
    useSpreadsheetQuery,
    useSpreadsheetUpdateMutation,
} from "../../api/spreadsheet.api";

interface ChildrenProps {
    data: any[];
    afterChange: (changes: CellChange[] | null, source: ChangeSource) => void;
}

interface Props {
    spreadsheetId: string;
    accessParams: SpreadsheetAccessParams;
    children: (props: ChildrenProps) => React.ReactNode;
}

export const PersistentSpreadsheet: React.FC<Props> = ({
    spreadsheetId,
    accessParams,
    children,
}) => {
    const { data } = useSpreadsheetQuery(spreadsheetId, accessParams, {
        refetchOnWindowFocus: false,
    });
    const updateMutation = useSpreadsheetUpdateMutation(
        spreadsheetId,
        accessParams,
    );

    const afterChange = useCallback(
        (changes: CellChange[] | null, source: ChangeSource) => {
            if (source === "loadData" || !changes) {
                return;
            }

            updateMutation.mutate({
                updates: changes.map((change) => ({
                    row: change[0],
                    column: change[1] as string,
                    value: change[3],
                })),
            });
        },
        [updateMutation],
    );

    if (!data) {
        return null;
    }

    return children({ data, afterChange });
};
